/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Option,
    OptionFromJSON,
    OptionFromJSONTyped,
    OptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface RejectReason
 */
export interface RejectReason {
    /**
     * 
     * @type {number}
     * @memberof RejectReason
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RejectReason
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof RejectReason
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RejectReason
     */
    nameJa: string;
    /**
     * 
     * @type {number}
     * @memberof RejectReason
     */
    displayOrder?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RejectReason
     */
    isOther: boolean;
    /**
     * 
     * @type {Array<Option>}
     * @memberof RejectReason
     */
    programTypes?: Array<Option>;
    /**
     * 
     * @type {boolean}
     * @memberof RejectReason
     */
    readonly hidden: boolean;
}

export function RejectReasonFromJSON(json: any): RejectReason {
    return RejectReasonFromJSONTyped(json, false);
}

export function RejectReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): RejectReason {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'name': json['name'],
        'nameJa': json['nameJa'],
        'displayOrder': !exists(json, 'displayOrder') ? undefined : json['displayOrder'],
        'isOther': json['isOther'],
        'programTypes': !exists(json, 'programTypes') ? undefined : ((json['programTypes'] as Array<any>).map(OptionFromJSON)),
        'hidden': json['hidden'],
    };
}

export function RejectReasonToJSON(value?: RejectReason | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'name': value.name,
        'nameJa': value.nameJa,
        'displayOrder': value.displayOrder,
        'isOther': value.isOther,
        'programTypes': value.programTypes === undefined ? undefined : ((value.programTypes as Array<any>).map(OptionToJSON)),
    };
}


